import { Link } from 'react-router-dom'
import Layout from '../layout/Layout'
import SEO from '../components/SEO'

function NotFound() {
  return (
    <Layout>
      <SEO
        title="Page not found | Papreja Tech Solutions"
        description="The page you are looking for could not be found. Return to Papreja Tech Solutions."
        path="/404"
      />
      <section className="flex min-h-[60vh] items-center justify-center bg-slate-50 px-5 py-20 text-center dark:bg-slate-950">
        <div>
          <p className="text-sm font-bold uppercase tracking-[0.2em] text-cyan-600 dark:text-cyan-400">Error 404</p>
          <h1 className="mt-4 text-4xl font-black tracking-tight text-slate-900 dark:text-white">Page not found</h1>
          <p className="mx-auto mt-4 max-w-md text-slate-600 dark:text-slate-300">That page does not exist or may have moved.</p>
          <Link to="/" className="mt-7 inline-flex rounded-lg bg-cyan-500 px-5 py-3 text-sm font-bold text-[#071a3d] transition hover:-translate-y-0.5 hover:bg-cyan-400">
            Return home
          </Link>
        </div>
      </section>
    </Layout>
  )
}

export default NotFound
